import { ParameterGenerateValuesRequest, ParameterGenerateObjectValuesRequest, ParameterSelectFieldRequest } from "@/backend/express/controllers/parameterController";
import { ParameterCreateRequest, ParameterReply, ParameterReadAllReply, ParameterUpdateRequest, ParameterUpdateReply, ParameterReadAllBySubjectRequest, SelectFieldReply, ParameterSubjectType } from "@/types/parameterTypes";
import { FusaReply } from "@/types/replyTypes";
import { Client } from "./client";

export class ParameterController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  public async createParameter(req: ParameterCreateRequest): Promise<ParameterReply> {
    return this.client.create('/api/parameters', req);
  }

  public async deleteParameter(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/parameters/${id}`);
  }

  public async updateParameter(req: ParameterUpdateRequest): Promise<ParameterUpdateReply> {
    return this.client.update('/api/parameters', req);
  }

  public async readParameter(id: string): Promise<ParameterReply> {
    return this.client.read(`/api/parameters/${id}`);
  }

  // REQUEST & RESPONSE TYPE CANNOT BE CHANGED - THIS ENDPOINT IS USED BY DESKTOP CLIENT
  public async readParametersBySubject(req: ParameterReadAllBySubjectRequest): Promise<ParameterReadAllReply> {
    const { subjectId, subjectType } = req;
    return this.client.read(`/api/parameters/${subjectType}/${subjectId}`);
  }

  public async readParametersByFunctionalInterface(functionalInterfaceId: string): Promise<ParameterReadAllReply> {
    return this.client.read(`/api/parameters/functional-interface/${functionalInterfaceId}`);
  }

  public async generateParameterValues(req: ParameterGenerateValuesRequest): Promise<ParameterReply> {
    return this.client.create('/api/parameters/generate', req);
  }

  public async generateObjectParameterValues(req: ParameterGenerateObjectValuesRequest): Promise<ParameterReply> {
    return this.client.create('/api/parameters/generateObjectParameterValues', req);
  }

  public async selectField(req: ParameterSelectFieldRequest): Promise<SelectFieldReply> {
    return this.client.update('/api/parameters/selectField', req);
  }

  public async readAllParametersBySubjects(subjectIds: string[], subjectType: ParameterSubjectType): Promise<ParameterReadAllReply> {
    return this.client.create(`/api/parameters/readAllParametersBySubjects`, { subjectIds, subjectType });
  }

  public async readByIds(ids: string[]): Promise<ParameterReadAllReply> {
    return this.client.create(`/api/parameters/readByIds`, { ids });
  }

  public async readAllParametersForImplementationFunction(implementationFunctionId: string): Promise<ParameterReadAllReply> {
    return this.client.read(`/api/parameters/implementation-function/${implementationFunctionId}`);
  }

  public async createProcedureTestParameters(procedureId: string): Promise<ParameterReadAllReply> {
    return this.client.create(`/api/parameters/createProcedureTestParameters/${procedureId}`, {});
  }
}
